export default "__VITE_ASSET__DbMNKX_y__"